import { inject } from '@angular/core';
import { CanDeactivateFn, UrlTree } from '@angular/router';
import { Observable, firstValueFrom } from 'rxjs';
import { AuthFacade } from 'store/auth-store/auth.facade';

export type CanDeactivateType =
  | Observable<boolean | UrlTree>
  | Promise<boolean | UrlTree>
  | boolean
  | UrlTree;

export interface CanComponentDeactivate {
  canDeactivate: () => CanDeactivateType;
}

export const CanDeactivateGuard: CanDeactivateFn<CanComponentDeactivate> = async (
  component: CanComponentDeactivate
) => {
  const authFacade = inject(AuthFacade);
  const patientId = await firstValueFrom(authFacade.patientId$);

  // always allow navigation if the user is logged out
  if (!patientId) {
    return true;
  }
  const canDeactivateResult = component.canDeactivate?.();

  if (canDeactivateResult instanceof Promise) {
    return await canDeactivateResult;
  }

  if (canDeactivateResult instanceof Observable) {
    return await firstValueFrom(canDeactivateResult);
  }

  return canDeactivateResult ?? true;
};
